import React, { useState } from 'react';
import {
    Modal,
    Box,
    Typography,
    Button,
    List,
    ListItem,
    ListItemText,
    styled,
} from '@mui/material';
import { getAppDisplayName } from '../utils/commonMethods';
import { useTranslation } from 'react-i18next';

interface AlertItem {
    label: string;
}

interface CustomAlertModalProps {
    medwerkerDateIssueAlert: AlertItem[] | null;
    projectDateIssueAlert: AlertItem[] | null;
    handleClose: () => void;
}

const ModalContainer = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 550,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 10,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
}));

const ScrollableContent = styled(Box)({
    maxHeight: 200,
    overflowY: 'auto',
});

const CustomAlertModal: React.FC<CustomAlertModalProps> = ({
    medwerkerDateIssueAlert,
    projectDateIssueAlert,
    handleClose,
}) => {
    const { t } = useTranslation();
    const [modalVisible, setModalVisible] = useState(true);

    const closeModal = () => {
        setModalVisible(false);
        handleClose();
    };

    return (
        <Modal
            open={modalVisible}
            onClose={() => setModalVisible(false)}
            aria-labelledby="custom-alert-modal"
            aria-describedby="custom-alert-description"
        >
            <ModalContainer>
                <Typography variant="h6" component="h2" gutterBottom>
                    {getAppDisplayName()}
                </Typography>

                <ScrollableContent>
                    {medwerkerDateIssueAlert && medwerkerDateIssueAlert.length > 0 && (
                        <Box mb={2}>
                            <Typography variant="body1" gutterBottom>
                                {t('taskDetailsUpdate.the_task_end_date_is_after_the_employees_departure_date')}
                            </Typography>
                            <List>
                                {medwerkerDateIssueAlert.map((item, index) => (
                                    <ListItem key={index} dense>
                                        <ListItemText primary={`• ${item.label}`} />
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    )}

                    {projectDateIssueAlert && projectDateIssueAlert.length > 0 && (
                        <Box>
                            <Typography variant="body1" gutterBottom>
                                {t('taskDetailsUpdate.the_task_end_date_is_beyond_the_project_completion_date')}
                            </Typography>
                        </Box>
                    )}
                </ScrollableContent>

                <Box display="flex" justifyContent="flex-end" mt={2}>
                    <Button
                        variant="contained"
                        sx={{
                            bgcolor: '#4CAF50',
                            color: 'white',
                            '&:hover': { bgcolor: '#45a049' }
                        }}
                        onClick={closeModal}
                    >
                        {t('common.label_ok')}
                    </Button>
                </Box>
            </ModalContainer>
        </Modal>
    );
};

export default CustomAlertModal;